import React, { useContext, useEffect, useState } from "react";
import "./css/Preview.scoped.css";
import recProdImg from "../assets/rec_prod.png";
import svg from "../assets/svg.png";
import banner from "../assets/banner.png";
import website from "../assets/website.png";
import websiteLight from "../assets/websiteLight.png";
import { StoreId } from "../Constants";
import { doc, getDoc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { CurrencyContext } from "../context/CurrencyContext";
import translate from "../i18n/translate";
export default function Preview({ dark }) {
  const [data, updateData] = useState([]);
  const [twoData, setTwoData] = useState([]);
  console.log(dark);
  let cart = localStorage.getItem("cart");
  const {
    rates,
    sign,
    sizingValues,
    womenSizingValues,
    girlSizingValues,
    toddler,
    young,
  } = useContext(CurrencyContext);

  let localCurrency = localStorage.getItem("currency");
  let localSizing = localStorage.getItem("sizing");

  useEffect(() => {
    const inventoryListener = onSnapshot(
      doc(db, "Stores", StoreId, "Cart", cart),
      async (snapShot) => {
        const conData = snapShot.data();
        updateData(conData.items);
      }
    );
    return () => {
      inventoryListener();
    };
  }, []);

  let getPrice = () => {
    let sum = 0;
    Object.keys(data).map((e) => {
      sum = sum + data[e].price;
    });
    return sum;
  };

  useEffect(() => {
    (async () => {
      let docRef = doc(
        db,
        "Stores",
        StoreId,
        "Customization",
        "CustViewSetting"
      );
      let docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const storeListener = onSnapshot(docRef, async (snapShot) => {
          let data = snapShot.data();
          setTwoData(data);
        });
        return () => {
          storeListener();
        };
      }
    })();
  }, []);

  return (
    <div className="preview">
      <div className="cart">
        <div className="flex jc-sp header">
          <div className="sm_header">{translate("customerPreviews")}</div>
          <div className="order_id">{translate("orderId")}-0001</div>
        </div>
        <div className="items">
          {Object.keys(data).map((e) => (
            <div key={data[e].id} className="item">
              <div className="info">
                <div className="name">{data[e].name}</div>
                <div className="code">{data[e].sku}</div>
                <div className="cond">
                  {data[e].condition},{" "}
                  {data[e].category === "sneakers"
                    ? sizingValues[localSizing][data[e].size]
                      ? sizingValues[localSizing][data[e].size]
                      : womenSizingValues[localSizing][data[e].size]
                      ? womenSizingValues[localSizing][data[e].size]
                      : girlSizingValues[localSizing][data[e].size]
                      ? girlSizingValues[localSizing][data[e].size]
                      : toddler[localSizing][data[e].size]
                      ? toddler[localSizing][data[e].size]
                      : young[localSizing][data[e].size]
                    : data[e].size}
                </div>
              </div>
              {/* <div className="btns flex al-ce">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 33 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="9.625"
                    y="15.125"
                    width="13.75"
                    height="2.75"
                    rx="1.375"
                    fill="#767BFA"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0 16.5C0 30.0877 2.91225 33 16.5 33C30.0877 33 33 30.0877 33 16.5C33 2.91225 30.0877 0 16.5 0C2.91225 0 0 2.91225 0 16.5ZM2.75 16.5C2.75 19.8342 2.93224 22.3258 3.35185 24.2138C3.76452 26.0707 4.36931 27.171 5.09914 27.9009C5.82896 28.6307 6.9293 29.2355 8.78615 29.6481C10.6742 30.0678 13.1658 30.25 16.5 30.25C19.8342 30.25 22.3258 30.0678 24.2138 29.6481C26.0707 29.2355 27.171 28.6307 27.9009 27.9009C28.6307 27.171 29.2355 26.0707 29.6481 24.2138C30.0678 22.3258 30.25 19.8342 30.25 16.5C30.25 13.1658 30.0678 10.6742 29.6481 8.78615C29.2355 6.9293 28.6307 5.82896 27.9009 5.09914C27.171 4.36931 26.0707 3.76452 24.2138 3.35185C22.3258 2.93224 19.8342 2.75 16.5 2.75C13.1658 2.75 10.6742 2.93224 8.78615 3.35185C6.9293 3.76452 5.82896 4.36931 5.09914 5.09914C4.36931 5.82896 3.76452 6.9293 3.35185 8.78615C2.93224 10.6742 2.75 13.1658 2.75 16.5Z"
                    fill="#ABAFD1"
                  />
                </svg>
                <span className="amt">1</span>
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 33 33"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.875 11C17.875 10.2406 17.2594 9.625 16.5 9.625C15.7406 9.625 15.125 10.2406 15.125 11V15.125H11C10.2406 15.125 9.625 15.7406 9.625 16.5C9.625 17.2594 10.2406 17.875 11 17.875H15.125V22C15.125 22.7594 15.7406 23.375 16.5 23.375C17.2594 23.375 17.875 22.7594 17.875 22V17.875H22C22.7594 17.875 23.375 17.2594 23.375 16.5C23.375 15.7406 22.7594 15.125 22 15.125H17.875V11Z"
                    fill="#767BFA"
                  />
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0 16.5C0 30.0877 2.91225 33 16.5 33C30.0877 33 33 30.0877 33 16.5C33 2.91225 30.0877 0 16.5 0C2.91225 0 0 2.91225 0 16.5ZM2.75 16.5C2.75 19.8342 2.93224 22.3258 3.35185 24.2138C3.76452 26.0707 4.36931 27.171 5.09914 27.9009C5.82896 28.6307 6.9293 29.2355 8.78615 29.6481C10.6742 30.0678 13.1658 30.25 16.5 30.25C19.8342 30.25 22.3258 30.0678 24.2138 29.6481C26.0707 29.2355 27.171 28.6307 27.9009 27.9009C28.6307 27.171 29.2355 26.0707 29.6481 24.2138C30.0678 22.3258 30.25 19.8342 30.25 16.5C30.25 13.1658 30.0678 10.6742 29.6481 8.78615C29.2355 6.9293 28.6307 5.82896 27.9009 5.09914C27.171 4.36931 26.0707 3.76452 24.2138 3.35185C22.3258 2.93224 19.8342 2.75 16.5 2.75C13.1658 2.75 10.6742 2.93224 8.78615 3.35185C6.9293 3.76452 5.82896 4.36931 5.09914 5.09914C4.36931 5.82896 3.76452 6.9293 3.35185 8.78615C2.93224 10.6742 2.75 13.1658 2.75 16.5Z"
                    fill="#ABAFD1"
                  />
                </svg>
              </div> */}
              <div className="price">
                {sign[localCurrency]}
                {(
                  data[e].price * rates?.[localCurrency?.toUpperCase()]
                ).toFixed(2)}
              </div>
            </div>
          ))}
        </div>
        <div className="details">
          <div
            className="sub_total"
            style={{
              opacity: 0,
            }}
          >
            <div>{translate("subTotal")}</div>
            <div className="total">0</div>
          </div>
          <div className="sub_total">
            <div>{translate("subTotal")}</div>
            <div className="total">
              {sign[localCurrency]}
              {(getPrice() * rates?.[localCurrency?.toUpperCase()]).toFixed(2)}
            </div>
          </div>
          <div className="sub_total">
            <div>{translate("discount")}</div>
            <div className="total">-</div>
          </div>
          <div className="sub_total">
            <div>{translate("tax")}</div>
            <div className="total">-</div>
          </div>
          <div className="sub_total">
            <div>{translate("total")}</div>
            <div className="total bold">
              {sign[localCurrency]}
              {(getPrice() * rates?.[localCurrency?.toUpperCase()]).toFixed(2)}
            </div>
          </div>
        </div>
      </div>
      <div className="suggestion">
        <div className="header pl-0">
          <div className="purple ">{translate("recommendedProducts")}</div>
        </div>
        <div className="horizontal_scroll">
          <div className="rec_item">
            <img className="shoeimg" src={recProdImg} alt="" />
            <div>
              <div className="shoename">Jordan 1 Low</div>
              <div className="model">Fragment x Travis Scott</div>
              <img className="svg" src={svg} alt="" />
            </div>
          </div>
          <div className="rec_item">
            <img className="shoeimg" src={recProdImg} alt="" />
            <div>
              <div className="shoename">Jordan 1 Low</div>
              <div className="model">Fragment x Travis Scott</div>
              <img className="svg" src={svg} alt="" />
            </div>
          </div>{" "}
          <div className="rec_item">
            <img className="shoeimg" src={recProdImg} alt="" />
            <div>
              <div className="shoename">Jordan 1 Low</div>
              <div className="model">Fragment x Travis Scott</div>
              <img className="svg" src={svg} alt="" />
            </div>
          </div>
        </div>
        <div className="more">
          <div className="purple custom">{translate("findOutMore")}...</div>

          <div className="more_container">
            <div className="showitem">
              <div
                className="item_heaeder"
                style={{
                  color: twoData?.mat1?.color,
                }}
              >
                {twoData?.mat1?.title}
              </div>
              <img src={twoData?.mat1?.bg} alt="" className="itemimg" />
            </div>
            <div className="border" />
            <div className="showitem">
              <div
                className="item_heaeder"
                style={{
                  color: twoData?.mat2?.color,
                }}
              >
                {twoData?.mat2?.title}
              </div>
              <img src={twoData?.mat2?.bg} alt="" className="itemimg" />
            </div>
            <div className="flex al-ce jc-sp w-100">
              <div className="flex al-ce">
                <img
                  style={{
                    width: "24px",
                  }}
                  src={dark ? websiteLight : website}
                  alt=""
                />
                <span className="text">
                  {twoData?.details?.storeUrl ?? "www.storename.com"}
                </span>
              </div>

              <div className="flex al-ce jc-fe">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M6.60427 0.0586825C5.31827 0.153542 4.10564 0.502418 3.16449 1.0483C2.58472 1.38456 1.39166 2.578 1.05551 3.15795C0.489291 4.13482 0.16521 5.2981 0.0603984 6.7303C-0.0201328 7.8305 -0.0201328 16.162 0.0603984 17.2622C0.16521 18.6944 0.489291 19.8576 1.05551 20.8345C1.39166 21.4145 2.58472 22.6079 3.16449 22.9442C4.14105 23.5106 5.30397 23.8347 6.73572 23.9396C7.83558 24.0201 16.1644 24.0201 17.2643 23.9396C18.696 23.8347 19.8589 23.5106 20.8355 22.9442C21.4153 22.6079 22.6083 21.4145 22.9445 20.8345C23.5107 19.8576 23.8348 18.6944 23.9396 17.2622C24.0201 16.162 24.0201 7.8305 23.9396 6.7303C23.8348 5.2981 23.5107 4.13482 22.9445 3.15795C22.6083 2.578 21.4153 1.38456 20.8355 1.0483C19.8589 0.481908 18.696 0.157725 17.2643 0.0528803C16.2567 -0.020862 7.61981 -0.0161393 6.60427 0.0586825ZM17.5969 2.27527C18.9361 2.46978 19.7675 2.84713 20.4826 3.58495C21.3607 4.49098 21.6725 5.425 21.7801 7.47157C21.8652 9.08965 21.8652 14.9028 21.7801 16.5209C21.6732 18.5544 21.3708 19.4686 20.5031 20.3809C19.6061 21.3239 18.6465 21.6615 16.5345 21.7768C14.9026 21.866 9.09743 21.866 7.4655 21.7768C5.36899 21.6623 4.50324 21.3641 3.56148 20.432C2.61669 19.4968 2.32836 18.6249 2.21127 16.3493C2.12096 14.5937 2.17667 7.1453 2.28593 6.36267C2.4557 5.14737 2.80811 4.33992 3.4794 3.62807C4.36363 2.69047 5.34019 2.32729 7.27874 2.21509C8.6562 2.13541 16.9677 2.18385 17.5969 2.27527ZM18.0698 4.16551C17.3784 4.37588 16.9814 4.88513 16.9814 5.56149C16.9814 6.84156 18.4633 7.50092 19.4088 6.64151C20.21 5.91327 19.8915 4.51054 18.8551 4.20269C18.4888 4.09386 18.3299 4.08637 18.0698 4.16551ZM11.1906 5.85241C10.545 5.94761 9.9617 6.12768 9.33586 6.42494C7.66082 7.22052 6.43201 8.73693 5.98585 10.5591C5.78345 11.3858 5.78345 12.6067 5.98585 13.4334C6.43228 15.2566 7.65752 16.768 9.33991 17.5708C10.2495 18.0048 10.9673 18.1616 12.0337 18.1591C13.0814 18.1567 13.7338 18.01 14.6641 17.5678C16.3399 16.7711 17.5687 15.2545 18.0139 13.4334C18.2178 12.5994 18.2185 11.3799 18.0156 10.5591C17.5638 8.73187 16.339 7.22086 14.6641 6.42467C14.3303 6.26599 13.8086 6.07303 13.5048 5.99598C12.8875 5.83939 11.7551 5.76916 11.1906 5.85241ZM12.9683 8.12257C13.5381 8.26965 14.2391 8.65077 14.6784 9.05241C16.7243 10.9228 16.2985 14.2337 13.8466 15.5196C13.2383 15.8387 12.6801 15.9768 12 15.9768C9.79773 15.9768 8.02065 14.1992 8.02065 11.9962C8.02065 10.2051 9.20852 8.64457 10.9546 8.1418C11.4761 7.99161 12.4256 7.98257 12.9683 8.12257Z"
                    fill={dark ? "#F6F7FF" : "#000"}
                  />
                </svg>

                <span className="text">
                  {twoData?.details?.instaUrl ?? "@testinstagram"}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
